import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { SubNavigationItem } from '../../sub-navigation/sub-navigation.models';

export enum LiveSubnavTabs {
    Overview = 1,
    EventView,
}

export function createSubnavTabs(urlHelper: UrlHelperService, sitecore: Sitecore, activeTab: LiveSubnavTabs): SubNavigationItem[] {
    return [
        {
            title: sitecore.liveNavigation.Overview,
            url: urlHelper.getLiveUrl(),
            active: activeTab === LiveSubnavTabs.Overview,
            id: LiveSubnavTabs.Overview,
        },
        {
            title: sitecore.liveNavigation.EventView,
            url: urlHelper.getEventUrl(),
            active: activeTab === LiveSubnavTabs.EventView,
            id: LiveSubnavTabs.EventView,
        },
    ].filter((tab) => tab.title);
}
